module.exports = __webpack_public_path__ + "img/brands-delijn.fab5703b.svg";